import { api } from "./interceptors";

export default api;

export { getAccessToken, setAccessToken, getDeviceId } from "./token";

export {
  ApiError,
  ApiErrorType,
  classifyError,
  getErrorMessage,
  isApiError,
  isErrorType,
  getUserErrorMessage
} from "./apiErrors";

export {
  handleApiError,
  createErrorHandler,
  createErrorMatcher,
  silentErrorHandler
} from "./handleApiError";


export type { UserRole } from "./types";
